import Vue from 'vue'
import VueRouter from 'vue-router'
import mainLayout from '@/views/htui/layout'


const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const routes = [
  /**
   * 登录路由
   */
  {
    path: '/loginPage',
    component: () => import('@/views/components/loginPage'),
    name: 'loginPage'
  },
  /**
   * 主路由
   */
  {
    path: '',
    component: mainLayout,
    redirect: '/index',
    children: [
      {
        path: '/index',
        component: () => import('@/views/htui/pages/index'),
        name: 'index'
      },
      {
        path: '/contract',
        component: () => import('@/views/htui/pages/contract/index'),
        hidden: true
      },
      {
        path: '/receipt',
        component: () => import('@/views/htui/pages/receipt/index'),
        hidden: true
      },

      {
        path: '/payment',
        component: () => import('@/views/htui/pages/payment/index'),
        hidden: true
      },
      {
        path: '/statistics',
        component: () => import('@/views/htui/pages/statistics/index'),
        hidden: true
      },
      {
        path: '/system',
        component: () => import('@/views/htui/pages/system/index'),
        hidden: true
      },
      {
        path: '/dataVisualization',
        component: () => import('@/views/htui/pages/dataVisualization/index'),
        hidden: true
      },
      {
        path: '/requisition',
        component: () => import('@/views/htui/pages/requisition/index'),
        hidden: true
      },
      {
        path: '/applyPayment',
        component: () => import('@/views/htui/pages/applyPayment/index'),
        hidden: true
      },
      {
        path: '/review',
        component: () => import('@/views/htui/pages/review/index'),
        hidden: true
      },
      {
        path: '/cashier',
        component: () => import('@/views/htui/pages/cashier/index'),
        hidden: true
      },
      {
        path: '/adminAudit',
        component: () => import('@/views/htui/pages/adminAudit/index'),
        hidden: true
      },
      {
        path: '/applicationForm',
        component: () => import('@/views/htui/pages/applicationForm/index'),
        hidden: true
      },

    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router

